module.exports = __webpack_public_path__ + "img/persona-banner1.16dc0af5.png";